import {
    ObjectAnalyticsObjectProperty,
    resolveObjectPropertyField,
} from '@/object-analytics/aggregations/object-analytics-object-property.helper';

export const FUNNEL_PRIMARY_KEY_TYPE = {
    VISITOR: 'visitor',
    ACCOUNT: 'account',
    OBJECT: 'object',
} as const;

export type FunnelPrimaryKeyType = (typeof FUNNEL_PRIMARY_KEY_TYPE)[keyof typeof FUNNEL_PRIMARY_KEY_TYPE];

export type FunnelPrimaryKey =
    | { type: 'visitor' }
    | { type: 'account' }
    | { type: 'object'; property: ObjectAnalyticsObjectProperty };

export interface ResolvedFunnelPrimaryKey {
    type: FunnelPrimaryKeyType;
    field: string;
}

// The funnel's unit of analysis is the aggregation group key. Absent config
// means visitor — keep that the single default so old and new saved funnels
// share one code path with no migration.
export function resolveFunnelPrimaryKey (config?: { primaryKey?: FunnelPrimaryKey } | null): ResolvedFunnelPrimaryKey {
    const primaryKey = config?.primaryKey;

    if (!primaryKey || primaryKey.type === FUNNEL_PRIMARY_KEY_TYPE.VISITOR) {
        return { type: FUNNEL_PRIMARY_KEY_TYPE.VISITOR, field: 'visitorId' };
    }

    if (primaryKey.type === FUNNEL_PRIMARY_KEY_TYPE.ACCOUNT) {
        return { type: FUNNEL_PRIMARY_KEY_TYPE.ACCOUNT, field: 'accountId' };
    }

    return { type: FUNNEL_PRIMARY_KEY_TYPE.OBJECT, field: resolveObjectPropertyField(primaryKey.property) };
}

export function isVisitorPrimaryKey (config?: { primaryKey?: FunnelPrimaryKey } | null): boolean {
    return resolveFunnelPrimaryKey(config).type === FUNNEL_PRIMARY_KEY_TYPE.VISITOR;
}

export function isAccountPrimaryKey (config?: { primaryKey?: FunnelPrimaryKey } | null): boolean {
    return resolveFunnelPrimaryKey(config).type === FUNNEL_PRIMARY_KEY_TYPE.ACCOUNT;
}
